import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubPortfolioGanttChartRoutingModule } from './sub-portfolio-gantt-chart-routing.module';
import { SubPortfolioGanttChartComponent } from './sub-portfolio-gantt-chart.component';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { DxDataGridModule, DxCheckBoxModule, DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { CurrencyFormatterPipeModule } from 'app/shared/currency-formatter-pipe/currencyFormatterPipe.module';
import { FormsModule } from '@angular/forms';
import { ProjectBudgetModule } from 'app/components/project-budget/project-budget.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    SubPortfolioGanttChartRoutingModule,
    I18nModule,
    DxDataGridModule,
    DxCheckBoxModule,
    CurrencyFormatterPipeModule,
    FormsModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    ProjectBudgetModule,
    MatPaginatorModule,
    NgxSpinnerModule
  ],
  declarations: [SubPortfolioGanttChartComponent,]
})
export class SubPortfolioGanttChartModule { }
